import styled from 'styled-components';
import { NamedProps } from 'react-select';

interface SelectSCProps {
  variation: 'lined' | 'round';
}

export const SelectSC = styled.div<SelectSCProps>`
  min-width: 170px;
  .ui-select {
    max-width: 100%;
  }

  .ui-react-select__value-container mark {
    background-color: transparent;
  }
`;

export const selectUnderlineStyles = (styles?: NamedProps['styles']): NamedProps['styles'] => {
  return {
    ...styles,
    option: (provided, state) => {
      return {
        cursor: 'pointer',
        fontSize: 14,
        fontFamily: 'Mulish, sans-serif',
        fontWeight: 400,
        textAlign: 'left',
        padding: '7px 15px',
        margin: '7px 15px',
        borderRadius: '8px',
        color: '#333D6C',
        '&:hover': {
          background: 'rgba(235, 236, 240, 0.5)',
        },
        ...styles?.option?.(provided, state),
      };
    },
    control: (provided, state) => {
      return {
        ...provided,
        background: 'transparent',
        border: 'none',
        boxShadow: 'none',
        borderBottom: '1px solid #333D6C',
        borderRadius: 0,
        ...styles?.control?.(provided, state),
      };
    },
    valueContainer: (provided, state) => {
      return {
        ...provided,
        cursor: 'pointer',
        background: 'transparent',
        fontFamily: 'Mulish, sans-serif',
        fontSize: 14,
        ...styles?.valueContainer?.(provided, state),
      };
    },
    singleValue: (provided, state) => ({
      ...provided,
      background: 'transparent',
      color: state.data.value === '' ? 'rgba(51, 61, 108, 0.4)' : '#333D6C',
      ...styles?.singleValue?.(provided, state),
    }),
    indicatorSeparator: (provided, state) => ({
      ...provided,
      display: 'none',
      margin: 0,
      ...styles?.indicatorSeparator?.(provided, state),
    }),
    menu: (provided, state) => ({
      ...provided,
      boxShadow: '0px 2px 15px rgba(51, 61, 108, 0.1)',
      margin: '2px 0 0',
      borderRadius: '8px',
      ...styles?.menu?.(provided, state),
    }),
    menuList: (provided, state) => ({
      padding: '8px 0',
      maxHeight: 300,
      overflow: 'auto',
      ...styles?.menuList?.(provided, state),
    }),
    multiValueLabel: (provided, state) => ({
      ...provided,
      color: '#333D6C',
      fontWeight: 700,
      paddingLeft: '12px',
      fontSize: '12px',
      ...styles?.multiValueLabel?.(provided, state),
    }),
    multiValueRemove: (provided, state) => ({
      ...provided,
      height: '100%',
      borderBottomRightRadius: '12px',
      borderTopRightRadius: '12px',
      padding: '2px',
      marginLeft: '5px',
      marginRight: '5px',
      '&:hover': {
        background: 'transparent',
      },
      ...styles?.multiValueRemove?.(provided, state),
    }),
    multiValue: (provided, state) => ({
      background: '#EBECF0',
      borderRadius: '12px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '3px 3px 3px 0',
      padding: '3px 0px',
      ...styles?.multiValue?.(provided, state),
    }),
    clearIndicator: (provided, state) => ({
      ...provided,
      display: 'none',
      ...styles?.clearIndicator?.(provided, state),
    }),
    dropdownIndicator: (provided, state) => ({
      color: '#333D6C',
      ...styles?.dropdownIndicator?.(provided, state),
    }),
    placeholder: (provided, state) => ({
      ...provided,
      color: 'rgba(51, 61, 108, 0.5)',
      ...styles?.placeholder?.(provided, state),
    }),
  };
};

export const selectBorderStyles = (styles?: NamedProps['styles']): NamedProps['styles'] => {
  return {
    option: (provided, state) => {
      return {
        cursor: 'pointer',
        fontSize: 14,
        fontFamily: 'Mulish, sans-serif',
        fontWeight: 400,
        textAlign: 'left',
        padding: '7px 15px',
        margin: '7px 15px',
        borderRadius: '8px',
        color: '#333D6C',
        '&:hover': {
          background: 'rgba(235, 236, 240, 0.5)',
        },
        ...styles?.option?.(provided, state),
      };
    },
    control: (provided, state) => {
      return {
        ...provided,
        background: 'transparent',
        boxShadow: 'none',
        border: '1px solid rgba(202, 204, 216, 0.6)',
        ...styles?.control?.(provided, state),
      };
    },
    valueContainer: (provided, state) => {
      return {
        ...provided,
        cursor: 'pointer',
        background: 'transparent',
        fontFamily: 'Mulish, sans-serif',
        fontSize: 14,
        ...styles?.valueContainer?.(provided, state),
      };
    },
    singleValue: (provided, state) => ({
      ...provided,
      background: 'transparent',
      color: state.data.value === '' ? 'rgba(51, 61, 108, 0.4)' : '#333D6C',
      ...styles?.singleValue?.(provided, state),
    }),
    indicatorSeparator: (provided, state) => ({
      ...provided,
      display: 'none',
      margin: 0,
      ...styles?.indicatorSeparator?.(provided, state),
    }),
    menu: (provided, state) => ({
      ...provided,
      boxShadow: '0px 2px 15px rgba(51, 61, 108, 0.1)',
      margin: '2px 0 0',
      borderRadius: '8px',
      ...styles?.menu?.(provided, state),
    }),
    menuList: (provided, state) => ({
      padding: '8px 0',
      maxHeight: 300,
      overflow: 'auto',
      ...styles?.menuList?.(provided, state),
    }),
    multiValueLabel: (provided, state) => ({
      ...provided,
      color: '#333D6C',
      fontWeight: 700,
      paddingLeft: '12px',
      fontSize: '12px',
      ...styles?.multiValueLabel?.(provided, state),
    }),
    multiValueRemove: (provided, state) => ({
      ...provided,
      height: '100%',
      borderBottomRightRadius: '12px',
      borderTopRightRadius: '12px',
      padding: '2px',
      marginLeft: '5px',
      marginRight: '5px',
      '&:hover': {
        background: 'transparent',
      },
      ...styles?.multiValueRemove?.(provided, state),
    }),
    multiValue: (provided, state) => ({
      background: '#EBECF0',
      borderRadius: '12px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '3px 3px 3px 0',
      padding: '3px 0px',
      ...styles?.multiValue?.(provided, state),
    }),
    clearIndicator: (provided, state) => ({
      ...provided,
      display: 'none',
      ...styles?.clearIndicator?.(provided, state),
    }),
    dropdownIndicator: (provided, state) => ({
      color: '#333D6C',
      marginRight: '8px',
      ...styles?.dropdownIndicator?.(provided, state),
    }),
    placeholder: (provided, state) => ({
      ...provided,
      color: 'rgba(51, 61, 108, 0.5)',
      ...styles?.placeholder?.(provided, state),
    }),
  };
};
